module.exports = __webpack_public_path__ + "static/img/xiehuo.3ffef8f3.svg";